<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-table titlePage="FUNCIONÁRIOS" :data="tableData" :columnsPDF="columnsPDF" :headRowsPDF="headRowsPDF" :fildsTXT="fildsTXT" :columnsExcel="columnsExcel" :bodyRowsPDF="bodyRowsPDF" colSpanPDF="7" :totalPDF="total" :titleReport="titleReport">
                <md-button v-if="permissoes.relatoriosView" class="md-button md-site md-just-icon md-round" :to="{ name: 'relatoriosView' }">
                    <md-icon>assignment</md-icon>
                    <md-tooltip md-direction="top">Relatórios</md-tooltip>
                </md-button>
            </header-table>
            <md-card-content>
                <div class="md-layout">
                    <div class="md-layout-item md-size-10 md-xsmall-size-40">
                        <md-field>
                            <label for="pages">Listar</label>
                            <md-select v-model="pagination.perPage" name="pages">
                                <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                                    {{ item }}
                                </md-option>
                            </md-select>
                        </md-field>
                    </div>

                    <div class="md-layout-item md-size-15 md-xsmall-size-60">
                        <md-field>
                            <label for="pages">Situação Funcionário</label>
                            <md-select v-model="dados.situacao_id" name="pages">
                                <md-option value="1">ATIVO</md-option>
                                <md-option value="2">INATIVO</md-option>
                            </md-select>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-30 md-xsmall-size-100">
                        <md-field>
                            <label>Pesquisar</label>
                            <md-input type="search" class="mb-3" clearable placeholder="NOME, CPF OU EMPRESA" v-model="buscar.busca">
                            </md-input>
                        </md-field>
                    </div>

                    <div class="md-layout-item md-size-10 md-xsmall-size-100">
                        <md-button @click="read()" class="md-site md-block md-round text-right md-sm">
                            <md-icon>search</md-icon>
                        </md-button>
                    </div>

                    <div class="md-layout-item md-size-35 md-xsmall-size-100 ml-auto">
                        <md-field md-clearable class="md-toolbar-section-end">
                            <md-input placeholder="Pesquise no resultado da busca aqui." v-model="search" @input="searchOnTable" />
                        </md-field>
                    </div>
                </div>
                <md-table :value="queriedData" class="paginated-table table-hover table-striped">
                    <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow">
                        <md-table-cell class="uppercase" md-label="ID" style="width: 8%">{{ item.id }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="FUNCIONÁRIO" style="width: 30%">{{ item.funcionario }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="CPF" style="width: 11%">{{ item.cpf_cnpj }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="CONTRATO" style="width: 8%">{{ item.contrato }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="EMPRESA" style="width: 30%">{{ item.empresa }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="LIMITE" style="width: 8%">{{ item.limite }}</md-table-cell>
                        <md-table-cell md-label="AÇÕES" style="width: 5%">
                            <md-menu md-direction="bottom-start" class="menuTable">
                                <md-button md-menu-trigger class="md-just-icon md-site md-round">
                                    <md-icon>menu</md-icon>
                                </md-button>

                                <md-menu-content>
                                    <md-menu-item v-if="permissoes.rhFuncionarioUpdate" @click="editar(item.id)">
                                        EDITAR <md-icon class="text-warning">edit</md-icon>
                                    </md-menu-item>
                                    <md-menu-item v-if="dados.situacao_id == 2 && permissoes.clientesInactivate" @click="inativar(item.id, item.funcionario)">
                                        ATIVAR<md-icon class="text-success">thumb_up_alt</md-icon>
                                    </md-menu-item>
                                    <md-menu-item v-if="dados.situacao_id == 1 && permissoes.clientesActivate" @click="inativar(item.id, item.funcionario)">
                                        INATIVAR<md-icon class="text-danger">thumb_down_alt</md-icon>
                                    </md-menu-item>
                                    <md-menu-item @click="visualizar(item.id)">
                                        VISUALIZAR<md-icon class="text-info">visibility</md-icon>
                                    </md-menu-item>
                                    <md-menu-item @click="showSwal(item.id)">
                                        OBSERVAÇÕES<md-icon class="text-info">comment</md-icon>
                                    </md-menu-item>
                                </md-menu-content>
                            </md-menu>

                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </md-card-content>
            <footer-table :from="from" :to="to" :total="total">
                <pagination class="pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total" />
            </footer-table>
        </md-card>
    </div>
</div>
</template>

<script>
import TableSearch from "@/config/mixins/tableSearch";
import HeaderTable from "@/pages/Layout/Extra/HeaderTable";
import FooterTable from "@/pages/Layout/Extra/FooterTable";
import Notify from '@/config/mixins/notify'
import {
    Pagination
} from "@/components";
import preLoader from '@/config/mixins/preLoader';
import Swal from "sweetalert2";

export default {
    name: 'PlanoRead',
    components: {
        HeaderTable,
        FooterTable,
        Pagination
    },

    data() {
        return {
            dados: {
                situacao_id: 1,
                tipo: 2
            },
            detalhes: {},
            rotaInactivate: 'clientes/inativar/',
            rotaActivate: 'clientes/ativar/',
            titleInactivate: 'INATIVAR?',
            titleReport: 'Relatório de Funcionários Ativos.',
            permissoes: this.$store.state.usuario.permissao,
            columnsPDF: [20, 45, 30, 22, 45, 20],
            headRowsPDF: ['ID', 'FUNCIONÁRIO', 'CPF', 'CONTRATO', 'EMPRESA', 'LIMITE'],
            bodyRowsPDF: ['id', 'funcionario', 'cpf_cnpj', 'contrato', 'empresa', 'limite'],
            fildsTXT: ['id', 'funcionario', 'cpf_cnpj', 'contrato', 'empresa', 'limite'],
            columnsExcel: [

                {
                    label: "ID",
                    field: "id"
                },
                {
                    label: "FUNCIONÁRIO",
                    field: "funcionario",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "CPF",
                    field: "cpf_cnpj"
                },
                {
                    label: "CONTRATO",
                    field: "contrato"
                },
                {
                    label: "EMPRESA",
                    field: "empresa",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "LIMITE",
                    field: "limite"
                }
            ],
            search: null,
            tableData: [],
            searchedData: [],
            buscar: {
                busca: '',
                dataInicial: null,
                dataFinal: null
            }
        };
    },

    watch: {
        'dados.situacao_id': function (value) {
            this.read()
            this.titleInactivate = value == 1 ? 'INATIVAR?' : 'ATIVAR?'
            this.titleReport = value == 1 ? 'Relatório de Funcionários Ativos.' : 'Relatório de Funcionários Inativos.'
        },
    },

    mixins: [TableSearch, Notify, preLoader],

    methods: {
        upperCaseFormat(value) {
            return value.toString().toUpperCase();
        },

        read(pagi) {
            this.buscar.situacao_id = this.dados.situacao_id
            let loader = this.openLoader('dots');
            pagi = pagi || this.$urlAPI + 'clientes/rh-funcionarios'
            this.$http.post(pagi, this.buscar)
                .then(response => {
                    if (response.data.status) {
                        this.tableData = response.data.dados
                        this.searchOnTable()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        searchByName(items, term) {
            if (term) {
                return items.filter(item => this.toLower([item.funcionario, item.cpf_cnpj, item.empresa, item.limite, item.contrato]).includes(this.toLower(term)))
            }
            return items
        },

        editar(id) {
            this.$router.push({
                name: 'rhFuncionarioUpdate',
                params: {
                    id: id
                }
            })
        },

        inativar(id, nome) {
            this.handleInactivate(id, nome)
        },

        visualizar(id) {
            this.$router.push({
                name: 'clientesView',
                params: {
                    id: id
                }
            })
        },

        showSwal(id) {
            Swal.fire({
                title: 'OBSERVAÇÕES',
                input: 'textarea',
                inputAttributes: {
                    autocapitalize: 'off'
                },
                showCancelButton: true,
                confirmButtonColor: '#0e8a3e',
                confirmButtonText: 'GRAVAR',
                cancelButtonText: 'SAIR',
                showLoaderOnConfirm: true,
                preConfirm: (text) => {
                    if (text == '' || text.length < 4) {
                        Swal.showValidationMessage(
                            'Digite um motivo de cancelamento válido.'
                        )
                    } else {
                        this.detalhes.id = id
                        this.detalhes.texto = text
                        this.details()
                    }
                },
            })
        },

        details() {
            this.$http.post(this.$urlAPI + 'clientes/detalhes', this.detalhes)
                .then(response => {
                    if (response.data.status) {
                        this.success(response.data.message)
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

    },

};
</script>
